"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.leapYaer = exports.ordinayYear = void 0;
exports.ordinayYear = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
exports.leapYaer = [0, 31, 60, 91, 121, 152, 182, 213, 244, 274, 305, 335];
